export const parallax = {
  RockRightObj: {
    signalActivate: ['BUTTON:startFreespin', 'INIT:FREESPINS'],
    signalRevert: ['STATE:IN:FS-END'],
    port: {
      duration: 3,
      x: 1170,
      pixi: { scaleY: 2 },
    },
    land: {
      duration: 3,
      x: 1170,
      pixi: { scaleY: 2 },
    },
  },
  RockLeftObj: {
    signalActivate: ['BUTTON:startFreespin', 'INIT:FREESPINS'],
    signalRevert: ['STATE:IN:FS-END'],
    port: {
      duration: 3,
      x: -975,
      pixi: { scaleY: 2 },
    },
    land: {
      duration: 3,
      x: -975,
      pixi: { scaleY: 2 },
    },
  },
  FreespinsObj: {
    signalActivate: ['BUTTON:startFreespin', 'INIT:FREESPINS'],
    signalRevert: ['STATE:IN:FS-END'],
    port: {
      duration: 3,
      pixi: { scaleY: 1.1 },
    },
    land: {
      duration: 3,
      pixi: { scaleY: 1.1 },
    },
  },
  RegularBgrEntity: {
    signalActivate: ['BUTTON:startFreespin', 'INIT:FREESPINS'],
    signalRevert: ['STATE:IN:FS-END'],
    port: {
      duration: 3,
      pixi: { scaleY: 1.1 },
      alpha: 0,
    },
    land: {
      duration: 3,
      pixi: { scaleY: 1.1 },
      alpha: 0,
    },
  },
  // BackObj: {
  //   signalActivate: ['BUTTON:barrel'],
  //   signalRevert: [],
  //   port: {
  //     duration: 2,
  //     x: -1480,
  //   },
  //   land: {
  //     duration: 2,
  //     x: -2320,
  //   },
  // },
  // MiddleObj: {
  //   signalActivate: ['BUTTON:barrel'],
  //   signalRevert: [],
  //   port: {
  //     duration: 2,
  //     x: -880,
  //   },
  //   land: {
  //     duration: 2,
  //     x: -670,
  //   },
  // },
  // ForegroundObj: {
  //   signalActivate: ['BUTTON:barrel'],
  //   signalRevert: [],
  //   port: {
  //     duration: 2,
  //     x: -1490,
  //   },
  //   land: {
  //     duration: 2,
  //     x: -2260,
  //   },
  // },
  // PiratReelsEntity: {
  //   signalActivate: ['BUTTON:barrel'],
  //   signalRevert: [],
  //   port: {
  //     duration: 2,
  //     x: 50,
  //   },
  //   land: {
  //     duration: 2,
  //     x: 329,
  //   },
  // },
  // BonesEntity: {
  //   signalActivate: ['BUTTON:barrel'],
  //   signalRevert: [],
  //   port: {
  //     duration: 2,
  //     x: -1490,
  //   },
  //   land: {
  //     duration: 2,
  //     x: -2260,
  //   },
  // },
  // LogoLayer: {
  //   signalActivate: ['BUTTON:barrel'],
  //   signalRevert: [],
  //   port: {
  //     duration: 2,
  //     x: -1490,
  //   },
  //   land: {
  //     duration: 2,
  //     x: -2260,
  //   },
  // },
}
